import produce from 'immer';

import {
  ADD_CRM_ISSUE_NOTE_FAILURE,
  ADD_CRM_ISSUE_NOTE_SUCCESS,
  ADD_SUBMISSION_TAGS_FAILURE,
  ADD_SUBMISSION_TAGS_SUCCESS,
  ADD_SUBMISSION_TASK_FAILURE,
  ADD_SUBMISSION_TASK_SUCCESS,
  CLEAR_CUSTOMER_SUBMISSION,
  CLEAR_CUSTOMER_SUBMISSION_LIST,
  CLEAR_ISSUE,
  CREATE_SUBMISSION_FAILURE,
  CREATE_SUBMISSION_SUCCESS,
  CRM_ADD_ATTACHMENT_FAILURE,
  CRM_ADD_ATTACHMENT_SUCCESS,
  CRM_DELETE_ATTACHMENTS_BY_ID,
  CRM_EDIT_LOCATION_FAILURE,
  CRM_EDIT_LOCATION_SUCCESS,
  CRM_ENTER_DRAFT_MODE,
  CRM_EXIT_DRAFT_MODE,
  CRM_LOCATION_SEARCH_CLEAR,
  CRM_LOCATION_SEARCH_FAILURE,
  CRM_LOCATION_SEARCH_SUCCESS,
  CRM_LOCATION_UPDATE,
  CRM_SUGGESTED_CATEGORIES_FETCH_SUCCESS,
  CRM_UPDATE_TASK_STATUS_FAILURE,
  CRM_UPDATE_TASK_STATUS_SUCCESS,
  CUSTOMER_SUBMISSION_FETCH_SUCCESS,
  CUSTOMER_SUBMISSION_LIST_FETCH_REQUEST,
  CUSTOMER_SUBMISSION_LIST_FETCH_SUCCESS,
  DELETE_CRM_ISSUE_NOTE_FAILURE,
  DELETE_CRM_ISSUE_NOTE_SUCCESS,
  DELETE_SUBMISSION_TASK_COMMENT_SUCCESS,
  DELETE_SUBMISSION_TASK_FAILURE,
  DELETE_SUBMISSION_TASK_SUCCESS,
  EDIT_CRM_ASSIGNEE_SUCCESS,
  EDIT_CRM_ISSUE_DUE_BY_DATE_FAILURE,
  EDIT_CRM_ISSUE_DUE_BY_DATE_SUCCESS,
  EDIT_CS_CATEGORY_FIELDS_FAILURE,
  EDIT_CS_CATEGORY_FIELDS_SUCCESS,
  EDIT_CS_CATEGORY_SUCCESS,
  EDIT_CS_COLLABORATOR_FAILURE,
  EDIT_CS_COLLABORATOR_SUCCESS,
  EDIT_CS_DISPLAY_ON_PUBLIC_MAP_FAILURE,
  EDIT_CS_DISPLAY_ON_PUBLIC_MAP_SUCCESS,
  EDIT_CS_VISIBILITY_FAILURE,
  EDIT_CS_VISIBILITY_SUCCESS,
  EDIT_SUBMISSION_TASK_COMMENT_FAILURE,
  EDIT_SUBMISSION_TASK_COMMENT_SUCCESS,
  EDIT_SUBMISSION_TASK_FAILURE,
  EDIT_SUBMISSION_TASK_SUCCESS,
  FETCH_ATTACHMENT_SOURCE_OPTIONS_FAILURE,
  FETCH_ATTACHMENT_SOURCE_OPTIONS_SUCCESS,
  FETCH_PRIVATE_SUBMISSION_LIST_LINK_FAILURE,
  FETCH_PRIVATE_SUBMISSION_LIST_LINK_SUCCESS,
  FETCH_RECENT_TAGS_FAILURE,
  FETCH_RECENT_TAGS_SUCCESS,
  FETCH_SECONDARY_CUSTOM_FIELDS_FAILURE,
  FETCH_SECONDARY_CUSTOM_FIELDS_SUCCESS,
  FETCH_SUBMISSION_TASK_FAILURE,
  FETCH_SUBMISSION_TASK_SUCCESS,
  GET_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE,
  GET_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS,
  GET_CRM_CHANNEL_OPTIONS_FAILURE,
  GET_CRM_CHANNEL_OPTIONS_REQUEST,
  GET_CRM_CHANNEL_OPTIONS_SUCCESS,
  GET_CRM_CLOSURE_OPTIONS_FAILURE,
  GET_CRM_CLOSURE_OPTIONS_REQUEST,
  GET_CRM_CLOSURE_OPTIONS_SUCCESS,
  GET_CRM_MAP_CONFIG_FAILURE,
  GET_CRM_MAP_CONFIG_SUCCESS,
  GET_CUSTOMER_SUBMISSION_HISTORY_FAILURE,
  GET_CUSTOMER_SUBMISSION_HISTORY_REQUEST,
  GET_CUSTOMER_SUBMISSION_HISTORY_SUCCESS,
  GET_PRIVATE_CSDP_DATA_SUCCESS,
  GET_PRIVATE_CSDP_MESSAGES_SUCCESS,
  GET_PRIVATE_SUBMISSIONS_LIST_SUCCESS,
  GROUP_ACTION_FAILURE,
  GROUP_ACTION_REQUEST,
  GROUP_ACTION_SUCCESS,
  SEND_CS_EMAIL_FAILURE,
  SEND_CS_EMAIL_SUCCESS,
  SEND_PRIVATE_CS_MESSAGE_SUCCESS,
  SUBMIT_ISSUE_FAILURE,
  SUBMIT_ISSUE_SUCCESS,
  UPDATE_CRM_ISSUE_ESCALATION_SUCCESS,
  UPDATE_CUSTOMER_SUBMISSION_STATUS_SUCCESS,
  UPDATE_EMAIL_READ_STATUS_FAILURE,
  UPDATE_EMAIL_READ_STATUS_SUCCESS,
  VALIDATE_CRM_FAILURE,
  VALIDATE_CRM_SUCCESS,
} from '@actions/crm';
import { DELETE_CASE_LINK_SUCCESS } from '@actions/xerceCase';

const initialState: ICRMStore = {
  issueLocation: null,
  suggestedCategories: null,
  anonymousSubmission: null,
  isEditMode: false,
  agencyDetails: null,
  issue: null,
  error: null,
  issueHistory: {
    submissionHistory: [],
    contactHistory: [],
  },
  customerSubmissionList: null,
  isFetching: false,
  customerSubmission: null,
  config: null,
  locationSearchResult: null,
  privateSubmissionListLink: null,
  privateCustomerSubmissionList: {
    createdBy: '',
    submissions: [],
  },
  recentTags: {
    count: 0,
    data: [],
  },
  secondaryFieldsCriteria: [],
  attachmentSourceOptions: [],
  channelOptions: null,
  channelOptionsError: false,
  isFetchingChannelOptions: false,
  closureOptions: null,
  closureOptionsError: false,
  isFetchingClosureOptions: false,
  groupActionResponse: {
    message: '',
  },
};

export default (state: ICRMStore = initialState, action: any) =>
  produce(state, (draftState: ICRMStore) => {
    switch (action.type) {
      case VALIDATE_CRM_SUCCESS:
        draftState.agencyDetails = action.response;
        draftState.error = null;

        return;

      case VALIDATE_CRM_FAILURE:
        draftState.agencyDetails = null;
        draftState.error = action.error;

        return;

      case GET_CRM_ANONYMOUS_ISSUE_DETAILS_SUCCESS:
        draftState.anonymousSubmission = action.response.data;
        draftState.error = null;

        return;

      case GET_CRM_ANONYMOUS_ISSUE_DETAILS_FAILURE:
        draftState.agencyDetails = null;
        draftState.error = action.error;

        return;

      case CUSTOMER_SUBMISSION_LIST_FETCH_REQUEST:
      case GET_CUSTOMER_SUBMISSION_HISTORY_REQUEST:
        draftState.isFetching = true;

        return;

      case CUSTOMER_SUBMISSION_LIST_FETCH_SUCCESS:
        draftState.customerSubmissionList = action.response;
        draftState.isFetching = false;

        return;

      case CLEAR_CUSTOMER_SUBMISSION_LIST:
        draftState.customerSubmissionList = null;
        draftState.isFetching = false;

        return;

      case SUBMIT_ISSUE_FAILURE:
        draftState.issue = null;
        draftState.error = action.error;

        return;

      case SUBMIT_ISSUE_SUCCESS:
      case CREATE_SUBMISSION_SUCCESS:
        draftState.issue = action.response;

        return;

      case CLEAR_ISSUE:
        draftState.issue = null;

        return;

      case EDIT_CS_CATEGORY_FIELDS_SUCCESS:
        draftState.customerSubmission.category.categoryCustomFields = action.response.categoryCustomFields;

        return;
      case EDIT_CRM_ISSUE_DUE_BY_DATE_SUCCESS:
        if (action.response && typeof action.response === 'object' && action.response.issueSummary) {
          draftState.customerSubmission = action.response;
        }

        return;

      case EDIT_CS_CATEGORY_SUCCESS:
      case EDIT_CS_COLLABORATOR_SUCCESS:
      case UPDATE_EMAIL_READ_STATUS_SUCCESS:
      case CUSTOMER_SUBMISSION_FETCH_SUCCESS:
      case GET_PRIVATE_CSDP_DATA_SUCCESS:
      case UPDATE_CUSTOMER_SUBMISSION_STATUS_SUCCESS:
      case UPDATE_CRM_ISSUE_ESCALATION_SUCCESS:
        draftState.customerSubmission = action.response;

        return;

      case CLEAR_CUSTOMER_SUBMISSION:
        draftState.customerSubmission = null;

        return;

      case EDIT_CRM_ASSIGNEE_SUCCESS:
        draftState.customerSubmission.issueSummary.assignee = action.response;

        return;

      case EDIT_CS_VISIBILITY_SUCCESS:
        draftState.customerSubmission.issueSummary.visibility = action.response;

        return;

      case EDIT_CS_DISPLAY_ON_PUBLIC_MAP_SUCCESS:
        if (draftState.customerSubmission) {
          draftState.customerSubmission.issueSummary.displayOnPublicMap = action.response;
        }

        return;

      case GET_CRM_MAP_CONFIG_SUCCESS:
        draftState.config = action.response;

        return;

      case CRM_ADD_ATTACHMENT_SUCCESS:
        draftState.customerSubmission.attachments = action.response;

        return;

      case DELETE_CRM_ISSUE_NOTE_SUCCESS:
        draftState.customerSubmission.notes = action.response;

        return;

      case ADD_CRM_ISSUE_NOTE_SUCCESS:
        draftState.customerSubmission.notes = action.response;

        return;

      case CRM_DELETE_ATTACHMENTS_BY_ID:
        const attachmentIds = action.response;
        const newAttachments = draftState.customerSubmission.attachments.filter(
          (attachment) => !attachmentIds.includes(attachment.id)
        );

        draftState.customerSubmission.attachments = newAttachments;

        return;

      case CRM_LOCATION_SEARCH_SUCCESS:
        draftState.locationSearchResult = action.response;

        return;

      case CRM_LOCATION_SEARCH_CLEAR:
        draftState.locationSearchResult = null;

        return;

      case CRM_SUGGESTED_CATEGORIES_FETCH_SUCCESS:
        draftState.suggestedCategories = action.response && action.response.categoryIds;

        return;

      case CRM_UPDATE_TASK_STATUS_SUCCESS:
        const customerSubmission = { ...draftState.customerSubmission };
        customerSubmission.tasks = customerSubmission.tasks.map((item) => {
          if (item.id === action.response.taskId) {
            return {
              ...item,
              history: action.response.history,
              status: action.response.status,
            };
          }

          return item;
        });

        draftState.customerSubmission = customerSubmission;

        return;

      case DELETE_SUBMISSION_TASK_COMMENT_SUCCESS:
        const submission = { ...draftState.customerSubmission };
        submission.tasks = submission.tasks.map((item) => {
          if (item.id === action.response.taskId) {
            return {
              ...item,
              history: action.response.history,
            };
          }

          return item;
        });

        draftState.customerSubmission = submission;

        return;

      case EDIT_SUBMISSION_TASK_COMMENT_SUCCESS:
        // tslint:disable-next-line: max-line-length
        const cs = { ...draftState.customerSubmission };
        const updatedCurrentTask = { ...cs.currentTask };
        updatedCurrentTask.comments = updatedCurrentTask.comments.map((commentItem) => {
          if (commentItem.id === action.response.id) {
            return {
              ...commentItem,
              ...action.response,
            };
          }

          return commentItem;
        });

        cs.currentTask = updatedCurrentTask;
        draftState.customerSubmission = { ...cs };

        return;

      case GET_CUSTOMER_SUBMISSION_HISTORY_SUCCESS:
        draftState.issueHistory = action.response;

        return;

      case ADD_SUBMISSION_TASK_SUCCESS:
      case EDIT_SUBMISSION_TASK_SUCCESS:
      case DELETE_SUBMISSION_TASK_SUCCESS:
        draftState.customerSubmission.tasks = action.response;

        return;

      case ADD_SUBMISSION_TAGS_SUCCESS:
        draftState.customerSubmission.tags = action.response;

        return;

      case GROUP_ACTION_REQUEST:
        // Reset so a later read can never see a prior batch's transitionedIssueIds.
        draftState.groupActionResponse = { message: '' };

        return;

      case GROUP_ACTION_SUCCESS:
        draftState.groupActionResponse = action.response;

        return;

      case EDIT_CRM_ISSUE_DUE_BY_DATE_FAILURE:
      case SEND_CS_EMAIL_FAILURE:
      case CRM_ADD_ATTACHMENT_FAILURE:
      case GET_CRM_MAP_CONFIG_FAILURE:
      case GET_CUSTOMER_SUBMISSION_HISTORY_FAILURE:
      case CRM_LOCATION_SEARCH_FAILURE:
      case EDIT_CS_COLLABORATOR_FAILURE:
      case EDIT_CS_DISPLAY_ON_PUBLIC_MAP_FAILURE:
      case EDIT_CS_VISIBILITY_FAILURE:
      case UPDATE_EMAIL_READ_STATUS_FAILURE:
      case DELETE_CRM_ISSUE_NOTE_FAILURE:
      case ADD_CRM_ISSUE_NOTE_FAILURE:
      case CREATE_SUBMISSION_FAILURE:
      case EDIT_CS_CATEGORY_FIELDS_FAILURE:
      case FETCH_PRIVATE_SUBMISSION_LIST_LINK_FAILURE:
      case ADD_SUBMISSION_TASK_FAILURE:
      case FETCH_SUBMISSION_TASK_FAILURE:
      case EDIT_SUBMISSION_TASK_FAILURE:
      case CRM_UPDATE_TASK_STATUS_FAILURE:
      case EDIT_SUBMISSION_TASK_COMMENT_FAILURE:
      case DELETE_SUBMISSION_TASK_FAILURE:
      case ADD_SUBMISSION_TAGS_FAILURE:
      case GROUP_ACTION_FAILURE:
        draftState.error = action.error;

        return;

      case CRM_EDIT_LOCATION_SUCCESS:
        draftState.customerSubmission.location = action.response;

        return;
      case CRM_LOCATION_UPDATE:
        draftState.issueLocation = action.payload;

        return;
      case CRM_EDIT_LOCATION_FAILURE:
        draftState.error = action.error;

        return;
      case CRM_ENTER_DRAFT_MODE:
        draftState.isEditMode = true;

        return;
      case CRM_EXIT_DRAFT_MODE:
        draftState.isEditMode = false;

        return;

      case SEND_CS_EMAIL_SUCCESS:
        draftState.customerSubmission.emails = action.response.emails;
        draftState.customerSubmission.attachments = action.response.attachments;

        return;
      case DELETE_CASE_LINK_SUCCESS:
        if (draftState.customerSubmission && draftState.customerSubmission.issueSummary.linkedCase) {
          draftState.customerSubmission.issueSummary.linkedCase = null;
        }

        return;
      case SEND_PRIVATE_CS_MESSAGE_SUCCESS:
        draftState.customerSubmission = action.response;

        return;

      case GET_PRIVATE_CSDP_MESSAGES_SUCCESS:
        if (draftState.customerSubmission) {
          draftState.customerSubmission.emails = action.response;
        }

        return;

      case FETCH_PRIVATE_SUBMISSION_LIST_LINK_SUCCESS:
        draftState.privateSubmissionListLink = action.response;

        return;

      case GET_PRIVATE_SUBMISSIONS_LIST_SUCCESS:
        draftState.privateCustomerSubmissionList = action.response;

        return;

      case FETCH_SUBMISSION_TASK_SUCCESS:
        draftState.customerSubmission.currentTask = action.response;

        return;

      case FETCH_RECENT_TAGS_SUCCESS:
        draftState.recentTags = action.response;

        return;
      case FETCH_RECENT_TAGS_FAILURE:
        draftState.recentTags = action.error;

        return;

      case FETCH_SECONDARY_CUSTOM_FIELDS_SUCCESS:
        draftState.secondaryFieldsCriteria = action.response;

        return;

      case FETCH_SECONDARY_CUSTOM_FIELDS_FAILURE:
        draftState.secondaryFieldsCriteria = action.error;

        return;

      case FETCH_ATTACHMENT_SOURCE_OPTIONS_SUCCESS:
        draftState.attachmentSourceOptions = action.response;

        return;

      case FETCH_ATTACHMENT_SOURCE_OPTIONS_FAILURE:
        draftState.attachmentSourceOptions = [];

        return;

      case GET_CRM_CHANNEL_OPTIONS_REQUEST:
        draftState.isFetchingChannelOptions = true;
        draftState.channelOptionsError = false;

        return;

      case GET_CRM_CHANNEL_OPTIONS_SUCCESS:
        draftState.channelOptions = action.response;
        draftState.channelOptionsError = false;
        draftState.isFetchingChannelOptions = false;

        return;

      case GET_CRM_CHANNEL_OPTIONS_FAILURE:
        draftState.channelOptions = null;
        draftState.channelOptionsError = true;
        draftState.isFetchingChannelOptions = false;

        return;

      case GET_CRM_CLOSURE_OPTIONS_REQUEST:
        draftState.isFetchingClosureOptions = true;
        draftState.closureOptionsError = false;

        return;

      case GET_CRM_CLOSURE_OPTIONS_SUCCESS:
        draftState.closureOptions = action.response;
        draftState.closureOptionsError = false;
        draftState.isFetchingClosureOptions = false;

        return;

      case GET_CRM_CLOSURE_OPTIONS_FAILURE:
        // Keep null (not []) so retry can distinguish failure from empty options.
        draftState.closureOptions = null;
        draftState.closureOptionsError = true;
        draftState.isFetchingClosureOptions = false;

        return;

      default:
        return;
    }
  });
